import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from '../errors';
import { AbstractComponentFlow } from './AbstractComponentFlow';
import { ManifestComponentExtensionType } from '../ManifestStore';
import { PanelStore } from '../PanelStore';
export class EditorReactComponentFlow extends AbstractComponentFlow {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", ManifestComponentExtensionType.BUILDER);
  }
  async loadManifest(_ref) {
    var _appDataComponent$dat;
    let {
      appDataComponent
    } = _ref;
    const builderComponent = appDataComponent;
    const manifest = builderComponent.data;

    // @ts-expect-error type is optional in the AppDataComponent data type
    const compType = (_appDataComponent$dat = appDataComponent.data) == null ? void 0 : _appDataComponent$dat.type;
    if (!manifest.type) {
      var _appComponent;
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestComponentTypeMissing).withComponentType(((_appComponent = builderComponent.appComponent) == null ? void 0 : _appComponent.id) || builderComponent.id || 'unknown_id');
    }
    if (manifest) {
      await this.manifestStore.setManifest(compType, ManifestComponentExtensionType.BUILDER, manifest);
    }
  }
  async loadPanels(_ref2) {
    var _appDataComponent$dat2;
    let {
      appDataComponent
    } = _ref2;
    // @ts-expect-error type is optional in the AppDataComponent data type
    const compType = (_appDataComponent$dat2 = appDataComponent.data) == null ? void 0 : _appDataComponent$dat2.type;
    const manifest = this.manifestStore.getManifest(compType);
    if (!manifest || !manifest.editorElement) {
      return;
    }
    const appData = this.manifestHelpers.getAppData(compType);
    const panels = await this._loadPanels(manifest.editorElement, appData);
    Object.keys(panels).forEach(actionName => {
      this.panelStore.setPanel(compType, actionName, panels[actionName]);
    });
    const tree = this.manifestHelpers.structure.getChildrenElementManifests(manifest);
    Object.keys(tree).map(async innerPath => {
      const _panels = await this._loadPanels(manifest, appData);
      Object.keys(_panels).forEach(actionName => {
        this.panelStore.setPanel(PanelStore.getPanelId(compType, innerPath.split('.')), actionName, _panels[actionName]);
      });
    });
  }
}
//# sourceMappingURL=EditorReactComponentFlow.js.map